import { openAccordionItem } from "../helpers"

export default () => {
  document.querySelectorAll('a[href*="#"]').forEach(link => {
    const url = new URL(link.href)
    if (url.pathname === window.location.pathname) {
      link.addEventListener("click", () => {
        if (link.hash !== "") {
          let accordionItem = document.querySelector(link.hash)

          if (accordionItem.classList.contains("accordion-item")) {
            openAccordionItem(accordionItem)
          } else {
            accordionItem = accordionItem.closest(".accordion-item")
            if (accordionItem) {
              openAccordionItem(accordionItem)
            }
          }
        }
      })
    }
  })
}
